import { Layout } from "../../components/layout";

export const PrivacyPolicyPage = () => {
  return (
    <Layout>
      <div className="w-full">
        <div className="bg-deep-primary">
          <div className="max-width flex flex-col md:flex-row md:items-center justify-between">
            <div className="flex flex-col gap-5 pt-[56px] md:pt-0">
              <h1 className="text-white font-medium text-[32px] md:text-[42px] leading-[40px] md:leading-[52px]">
                <p>Privacy</p>
                <p>Policy</p>
              </h1>
              <h3 className="text-white">
                MYCARD GLOBAL PLATFORM OPERATED BY MYCARD TECH SOLUTIONS LTD
              </h3>
              <p className="text-yellow text-lg font-medium">
                Effective Date: 01/01/2025
              </p>
            </div>

            <img
              src={"/assets/images/privacy.svg"}
              alt="information"
              className="block w-full max-w-[445px]"
            />
          </div>
        </div>

        <article
          className="
          max-width
          py-[64px] lg:py-[96px]
          text-base lg:text-lg leading-[24px] lg:leading-[28px]
          text-grey-700
          "
        >
          <div className="px-4 lg:px-8 flex flex-col gap-10">
            <h2 className="text-[18px ]lg:text-[24px] leading-[28px] lg:leading-[30px] font-bold text-grey-900 uppercase">
              About MyCardGlobal
            </h2>
            <p>
              MyCardGlobal is an app operated by MyCard Tech Solutions Ltd.
              Founded in 2023, MyCard Tech Solutions Limited is an innovative
              fintech company focused on simplifying how people save, manage,
              and invest money. With a strong commitment to security,
              innovation, and customer-first solutions, the platform offers
              seamless financial services including digital card solutions,
              Autosave, Flexsave, Vault, and soft loans.
            </p>
            <p>
              By combining competitive interest rates with easy-to-use savings
              and investment tools, MyCardGlobal empowers individuals to build a
              sustainable savings culture that is simple, secure, and accessible
              to all.
            </p>
            <p>
              At MyCard Tech Solutions Ltd, your privacy is important to us.
              This Privacy Policy explains how we collect, use, store, and
              protect your personal information when you use our services
              through{" "}
              <a className="text-primary" href="http://www.mycardglobal.com">
                www.mycardglobal.com
              </a>
              .
              <br />
              By accessing our platform and using our services, you consent to
              the practices outlined in this policy.
            </p>

            {/* <div className="flex flex-col gap-8"></div> */}
            <ol>
              <li className="list-inside list-decimal text-[18px ]lg:text-[24px] leading-[28px] lg:leading-[30px] font-bold text-grey-900 uppercase mb-4">
                LOAN PROVIDER/LENDER INFORMATION
              </li>
              <p>
                The loan products and credit services offered through the MyCard
                Global App are provided by MyCard Tech Solutions Ltd [Lender], a
                Money Lender incorporated in Nigeria with RC No. 8276710 and
                licensed by the Central Bank of Nigeria. MyCard Tech Solutions
                Ltd operates{" "}
                <a className="text-primary" href="http://www.mycardglobal.com">
                  www.mycardglobal.com
                </a>{" "}
                and the MyCard Global App as a technology platform. All loan
                products and credit services offered through theMyCard Global
                App are provided directly by MyCard Tech Solutions Ltd. All loan
                applications are subject to approval by MyCard Tech Solutions
                Ltd, and all loan agreements are between you and MyCard Tech
                Solutions Ltd.
              </p>
              <li className="list-inside list-decimal text-[18px ]lg:text-[24px] leading-[28px] lg:leading-[30px] font-bold text-grey-900 uppercase my-4">
                INFORMATION WE COLLECT
              </li>
              <p className="my-4">
                When you use the MyCard Global App, MyCard Tech Solutions Ltd
                may collect the following types of personal and non-personal
                information:
              </p>
              <ol type="a" className="list-inside list-lower">
                <li className="font-bold text-grey-700 text-xl my-4">
                  Personal Information
                </li>
                <ul className="list-disc list-inside pl-3">
                  <li>Full name</li>
                  <li>Email address</li>
                  <li>Phone number</li>
                  <li>Date of birth</li>
                  <li>Government-issued ID</li>
                  <li>BVN/NIN</li>
                  <li>Payment and transaction details</li>
                  <li>Bank account details</li>
                  <li>Location data (when permitted)</li>
                  <li>Credit history</li>
                </ul>
                <li className="font-bold text-grey-700 text-xl my-4">
                  Non-Personal Information
                </li>
                <ul className="list-disc list-inside pl-3">
                  <li>Device type and browser</li>
                  <li>IP address</li>
                  <li>Cookies and usage data</li>
                  <li>Platform navigation behavior</li>
                </ul>
              </ol>
              <li className="list-inside list-decimal text-[18px ]lg:text-[24px] leading-[28px] lg:leading-[30px] font-bold text-grey-900 uppercase my-4">
                HOW WE USE YOUR INFORMATION
              </li>
              <p className="my-4">We use your information to:</p>
              <ul className="list-disc list-inside pl-3">
                <li>
                  Provide and manage loan and financial services on behalf of
                  MyCard Tech Solutions Ltd.
                </li>
                <li>
                  Verify your identity, assess creditworthiness, and prevent
                  fraud.
                </li>
                <li>
                  Process loan applications, disburse funds, and manage
                  repayments.
                </li>
                <li>
                  Comply with legal obligations, CBN, and NDPA requirements.
                </li>
                <li>Communicate important updates or service information.</li>
                <li>
                  Improve the performance, security, and usability of our
                  platform.
                </li>
              </ul>
              <li className="list-inside list-decimal text-[18px ]lg:text-[24px] leading-[28px] lg:leading-[30px] font-bold text-grey-900 uppercase my-4">
                HOW WE SHARE YOUR INFORMATION
              </li>
              <p className="my-4">We may share your information with:</p>
              <ul className="list-disc list-inside pl-3">
                <li>
                  MyCard Tech Solutions Ltd and its affiliates for loan
                  processing and servicing.
                </li>
                <li>
                  Service providers (e.g., payment processors, credit bureaus,
                  cloud storage) under contract.
                </li>
                <li>
                  Regulatory authorities such as CBN, and law enforcement, where
                  required by law.
                </li>
                <li>Business partners, only with your consent.</li>
                <p>
                  We do not sell or rent your personal information to third
                  parties.
                </p>
              </ul>
              <li className="list-inside list-decimal text-[18px ]lg:text-[24px] leading-[28px] lg:leading-[30px] font-bold text-grey-900 uppercase my-4">
                DATA SECURITY
              </li>
              <p className="my-4">
                We implement industry-standard security practices to protect
                your data such as:
              </p>
              <ul className="list-disc list-inside pl-3">
                <li>Encryption of sensitive data.</li>
                <li>Secure servers and access controls.</li>
                <li>Continuous monitoring for security threats.</li>
                <p>
                  In compliance with NDPA 2023, MyCard Tech Solutions Ltd is
                  responsible for enforcing all technical and organisational
                  safeguards in protecting your data.
                </p>
              </ul>
              <li className="list-inside list-decimal text-[18px ]lg:text-[24px] leading-[28px] lg:leading-[30px] font-bold text-grey-900 uppercase my-4">
                HOW WE SHARE YOUR INFORMATION
              </li>
              <p className="my-4">We may share your information with:</p>
              <ul className="list-disc list-inside pl-3">
                <li>
                  MyCard Tech Solutions Ltd and its affiliates for loan
                  processing and servicing.
                </li>
                <li>
                  Service providers (e.g., payment processors, credit bureaus,
                  cloud storage) under contract.
                </li>
                <li>
                  Regulatory authorities such as CBN, and law enforcement, where
                  required by law.
                </li>
                <li>Business partners, only with your consent.</li>
                <p>
                  We do not sell or rent your personal information to third
                  parties.
                </p>
              </ul>
              <li className="list-inside list-decimal text-[18px ]lg:text-[24px] leading-[28px] lg:leading-[30px] font-bold text-grey-900 uppercase my-4">
                YOUR RIGHTS AND CHOICES
              </li>
              <p className="my-4">Under NDPA 2023, you have the right to:</p>
              <ul className="list-disc list-inside pl-3">
                <li>Access and update your personal information.</li>
                <li>
                  Request deletion of your data (subject to regulatory
                  requirement).
                </li>
                <li>Withdraw consent for data processing.</li>
                <li>Opt out of marketing communications.</li>
                <p>
                  To exercise any of these rights, contact us at support at:{" "}
                  <a
                    className="text-primary"
                    href="mailto:support@mycardglobal.com"
                  >
                    support@mycardglobal.com
                  </a>
                </p>
              </ul>
              <li className="list-inside list-decimal text-[18px ]lg:text-[24px] leading-[28px] lg:leading-[30px] font-bold text-grey-900 uppercase my-4">
                COOKIES
              </li>
              <p>
                We use cookies to enhance your user experience. You can manage
                or disable cookies through your browser settings.
              </p>
              <li className="list-inside list-decimal text-[18px ]lg:text-[24px] leading-[28px] lg:leading-[30px] font-bold text-grey-900 uppercase my-4">
                RETENTION OF DATA
              </li>
              <p>
                We retain your personal data only for as long as necessary to
                fulfill the purposes outlined in this policy or to comply with
                CBN regulations, which require a minimum retention period of 7
                years for financial records.
              </p>
              <li className="list-inside list-decimal text-[18px ]lg:text-[24px] leading-[28px] lg:leading-[30px] font-bold text-grey-900 uppercase my-4">
                CHILDREN’S PRIVACY
              </li>
              <p>
                Our services are not directed at individuals under the age of
                18. We do not knowingly collect personal information from
                children.
              </p>
              <li className="list-inside list-decimal text-[18px ]lg:text-[24px] leading-[28px] lg:leading-[30px] font-bold text-grey-900 uppercase my-4">
                CHANGES TO THIS PRIVACY POLICY
              </li>
              <p>
                We may update this Privacy Policy from time to time. All changes
                will be posted on this page with an updated effective date.
              </p>
              <li className="list-inside list-decimal text-[18px ]lg:text-[24px] leading-[28px] lg:leading-[30px] font-bold text-grey-900 uppercase my-4">
                CONTACT US
              </li>
              <p>
                For questions regarding your loan account, repayment, or terms,
                please contact MyCard Tech Solutions Ltd directly at:
              </p>
              <br />
              <div>
                <p>
                  Platform Operator and Loan Provider: MyCard Tech Solutions Ltd
                </p>
                <p>
                  Email:{" "}
                  <a
                    className="text-primary"
                    href="mailto:support@mycardglobal.com"
                  >
                    support@mycardglobal.com
                  </a>
                </p>
                <p>
                  Website:{" "}
                  <a
                    className="text-primary"
                    href="http://www.mycardglobal.com"
                  >
                    www.mycardglobal.com
                  </a>
                </p>
              </div>
            </ol>
          </div>
        </article>
      </div>
    </Layout>
  );
};
